// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

type Props = {
  menuEl: any,
  menuItems: Array,
  classes: Object
}

type State = {
  menuOpen: boolean
}

class Dropdown extends React.Component<Props, State> {
  anchorEl: ?HTMLElement;

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false
    };
  }

  handleOpenMenu = (event) => {
    this.anchorEl = event.currentTarget;
    this.setState({ menuOpen: true });
  }

  handleCloseMenu = () => {
    this.setState({ menuOpen: false });
  }

  renderMenuItems = () => {
    const { menuItems } = this.props;

    return menuItems.map((item, index) => {
      const handleItemClick = () => {
        item.onClick();
        this.handleCloseMenu();
      }

      return (
        <MenuItem onClick={handleItemClick} key={index}>{item.display}</MenuItem>
      );
    });
  };

  renderMenu = () => {
    return (
      <Menu
        anchorEl={this.anchorEl}
        open={this.state.menuOpen}
        onClose={this.handleCloseMenu}
      >
        {this.renderMenuItems()}
      </Menu>
    );
  }

  render() {
    const { menuEl } = this.props;

    return (
      <div>
        <div onClick={this.handleOpenMenu}>
          {menuEl}
        </div>
        {this.renderMenu()}
      </div>
    )
  }
};

const styles = {};

export default withStyles(styles)(Dropdown);



// WEBPACK FOOTER //
// ./src/components/core/Dropdown.js